
document.addEventListener('DOMContentLoaded',()=>{
  const els=document.querySelectorAll('.mcd-reveal');
  if(!('IntersectionObserver' in window)) return;
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.style.opacity='1';e.target.style.transform='translateY(0)';io.unobserve(e.target)}});
  },{threshold:.08});
  els.forEach(el=>{el.style.opacity='0';el.style.transform='translateY(18px)';el.style.transition='opacity .7s ease,transform .7s ease';io.observe(el)});
});


document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-mcd-repair-form]').forEach(form=>{
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const whatsapp=(form.dataset.whatsapp||'').replace(/\D/g,'');
      if(!whatsapp){
        alert('Configure o número do WhatsApp no editor do tema: Macedo Tech — Home.');
        return;
      }
      const data=new FormData(form);
      const device=(data.get('device')||'').toString().trim();
      const issue=(data.get('issue')||'').toString().trim();
      const details=(data.get('details')||'').toString().trim();
      const msg=[
        'Olá! Vim pelo site da Macedo Tech e gostaria de solicitar um orçamento.',
        '',
        '📱 Aparelho/modelo: '+device,
        '🛠️ Problema: '+issue,
        details ? '📝 Detalhes: '+details : '',
        '',
        'Pode me orientar sobre o diagnóstico e o orçamento?'
      ].filter(Boolean).join('\n');
      window.open('https://wa.me/'+whatsapp+'?text='+encodeURIComponent(msg),'_blank','noopener');
    });
  });
});

// Macedo Tech V2.2 — avaliação para compra de celular com tela quebrada
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-mcd-sell-form]').forEach(form=>{
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const whatsapp=(form.dataset.whatsapp||'').replace(/\D/g,'');
      if(!whatsapp){
        alert('O WhatsApp da Macedo Tech ainda não está configurado.');
        return;
      }
      const data=new FormData(form);
      const device=(data.get('device')||'').toString().trim();
      const screen=(data.get('screen')||'').toString().trim();
      const details=(data.get('details')||'').toString().trim();
      const msg=[
        'Olá! Vim pelo site da Macedo Tech e quero solicitar uma avaliação para vender meu celular com a tela quebrada.',
        '',
        '📱 Aparelho/modelo: '+device,
        '💥 Estado da tela: '+screen,
        details ? '📝 Outras informações: '+details : '',
        '',
        'Confirmo que o aparelho possui tela/vidro quebrado.',
        'Podem me orientar sobre a avaliação e uma possível proposta?'
      ].filter(Boolean).join('\n');
      window.open('https://wa.me/'+whatsapp+'?text='+encodeURIComponent(msg),'_blank','noopener');
    });
  });
});
